//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum MoySkladStockType {
  /** Физический остаток на складах, без учёта резерва и ожидания */
  stock = 0,
  /** Остаток на складах за вычетом резерва */
  freeStock = 1,
  /** Доступно. Учитывает резерв и ожидания */
  quantity = 2
}
